import React, { useState } from 'react';
import { Alert, Modal, Box, ButtonGroup, Button, IconButton, InputAdornment, List, Paper, Stack, TextField, Typography } from '@mui/material';
import { toast } from 'react-toastify';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import Styles from '../../../common/styles/styles';
import { validatePassword, validateConfirmPassword } from '../../../common/utils/validationUtil';


function UserPwModal({ user, onTriggerPWUpdate }) {

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => {
        setFormData({ 
            userId: '',
            newPassword: '',
            confirmPassword: '', 
            // password: ''
        }); 
        setOpen(false);
    }
    const title = 'Reset Password';
    const [errors, setErrors] = useState({});
    
    const isFormValid = Object.values(errors).filter(value => value !=='').length > 0;
    
    const togglePasswordVisibility = (field) => {
        setShowPasswords(prev => ({
        ...prev,
        [field]: !prev[field]
        }));
    };

    const [showPasswords, setShowPasswords] = useState({
        current: false,
        new: false,
        confirm: false,
    });

    const [formData, setFormData] = useState({
        userId: '',
        newPassword: '',
        confirmPassword: '',
    });

    const handleInputChange = (field) => (e) => {      
        const value = e.target.value;
        setFormData({ ...formData, [field]: value });
      
        const newErrors = { ...errors };
      
        if (field === 'newPassword') newErrors.newPassword = validatePassword(value);
        if (field === 'confirmPassword') newErrors.confirmPassword = validateConfirmPassword( formData.newPassword, value);
      
        setErrors(newErrors);
    };

    const handleUpdate = async (event) => {
        event.preventDefault();
        event.stopPropagation();    
        const result = await updatePassword();
        if (result === 'success') {
            onTriggerPWUpdate(user);
        }
    };

    const updatePassword = async () => {
    
        try {    
            formData.userId = user.id;
            
            const response = await fetch(`${process.env.REACT_APP_API}/users/resetPassword`, {
                method: 'PUT',
                headers: {
                'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            const result = await response.json();
            if (result.message === 'success') {
                handleClose();
            } else {
                toast.error(result.message);
            }
            return result.message;
        } catch (error) {
            console.error('Network error.  Please try again: ', error);
            return 'error';
        }
    };    

    const textFieldStyles = Styles.textFieldStyles;

    return (
        <>
            <Button variant="outlined" color="primary" size="small" onClick={handleOpen}>
                <LockOpenIcon />
            </Button>
            
            <Modal 
                open={open} 
                onClose={handleClose}
                style={{
                    overlay: {
                    backgroundColor: '#080030', // Semi-transparent black
                    },
                    content: {
                    backgroundColor: '#080030',
                    },
                }}
            >
               
                <Box sx={{color: 'white', p: 4}}>
                    <Box
                            component={Paper}
                            elevation={3}
                            sx={{
                              mx: 'auto',
                              width: 400,
                              bgcolor: '#1e1e1e',
                              p: 2,
                            }}
                          >
                            {errors.submit && (
                              <Alert severity="error" sx={{ mb: 3 }}>
                                {errors.submit}
                              </Alert>
                            )}

                            <Typography variant="h4" component="h2" color="white" mb={2}>
                                {title}
                            </Typography>

                            <Box component="form" onSubmit={handleUpdate}>
                                <Stack spacing={2}>
                                    <TextField
                                        required
                                        fullWidth
                                        label="New Password"
                                        type={showPasswords.new ? 'text' : 'password'}
                                        value={formData.newPassword}
                                        onChange={handleInputChange('newPassword')}
                                        error={!!errors.newPassword}
                                        helperText= 
                                        {
                                        errors.newPassword ? 
                                            errors.newPassword.map((err) => (
                                            <List>{err}</List>
                                            ))
                                        :
                                            null
                                        }
                                        sx={textFieldStyles}
                                        slotProps={{
                                            input: {
                                            autoComplete: 'new-password',
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                <IconButton
                                                    onClick={() => togglePasswordVisibility('new')}
                                                    edge="end"
                                                    sx={{ color: 'rgba(255, 255, 255, 0.7)' }}
                                                >
                                                    {showPasswords.new ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                                </InputAdornment>
                                            ),
                                            }
                                        }}
                                    />
                        
                                    <TextField
                                        required
                                        fullWidth
                                        label="Confirm New Password"
                                        type={showPasswords.confirm ? 'text' : 'password'}
                                        value={formData.confirmPassword}
                                        onChange={handleInputChange('confirmPassword')}
                                        error={!!errors.confirmPassword}
                                        helperText= 
                                        {
                                        errors.confirmPassword ? 
                                            errors.confirmPassword.map((err) => (
                                            <List>{err}</List>
                                            ))
                                        :
                                            null
                                        }
                                        sx={textFieldStyles}
                                        slotProps={{
                                            input: {
                                            autoComplete: 'new-password',
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                <IconButton
                                                    onClick={() => togglePasswordVisibility('confirm')}
                                                    edge="end"
                                                    sx={{ color: 'rgba(255, 255, 255, 0.7)' }}
                                                >
                                                    {showPasswords.confirm ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                                </InputAdornment>
                                            ),
                                            }
                                        }}
                                    />
                        
                                    <ButtonGroup 
                                        size="small"
                                        variant="contained" 
                                        aria-label="Basic button group" 
                                        fullWidth
                                    >
                        
                                        <Button
                                            onClick={handleClose}
                                            type="cancel"
                                            variant="contained"
                                            sx={ Styles.buttonStyle }
                                        >
                                            {'Cancel '}
                                        </Button>

                                        <Button
                                            type="submit"
                                            variant="contained"
                                            disabled={isFormValid}
                                            sx={{ ...Styles.buttonStyle,  ml:4 }}
                                        >
                                            {title}
                                        </Button>
                                    </ButtonGroup>
                                </Stack>
                            </Box>
                        </Box>
                </Box>
            </Modal>            
        </>
    );
}

export default UserPwModal;